import React from 'react';
import { navigate } from 'gatsby';
import { useAnalytics } from '../../../../../utils/analytics-provider/analytics-provider';
import { StyledContainer, StyledButton } from './styles';

const Support = () => {
  const { trackEvent } = useAnalytics();

  return (
    <StyledContainer>
      <StyledButton
        color="secondary"
        href="#"
        onClick={() => {
          trackEvent('content_engagement_v2', {
            engagement_type: 'browse_articles_link_click'
          });

          navigate('/');
        }}
      >
        Browse Support Articles
      </StyledButton>
    </StyledContainer>
  );
};

export default Support;
